import { LogoScreenStyled } from './styled/LogoScreenStyled';
import LogoIcon from './LogoIcon';

export const LogoScreen = () => {
    return <LogoScreenStyled>
        <LogoIcon/>
    </LogoScreenStyled>;
};

export default LogoScreen;
